module.exports = __webpack_public_path__ + "img/friend-1.89472fc5.png";